import { useDispatch } from 'react-redux';
import { recordActions } from '../../../config/configuration/react';

export const useDeleteRecord = ({ recordId, toggle }) => {
  const dispatch = useDispatch();

  const cancelAppointment = () => {
    dispatch(recordActions.cancelAppointment(recordId));
    toggle();
  };

  return {
    cancelAppointment,
    isError: false,
    error: '',
  };
};
